import { getCreatedTimeMsFromCreated } from "./dateUtils";
import { isTapeReading } from "./tradeHelpers";

function roundToCents(value) {
  return Math.round((Number(value) || 0) * 100) / 100;
}

export function getEntrySortTimeMs(entry) {
  const createdMs = getCreatedTimeMsFromCreated(entry?.created);
  if (createdMs > 0) return createdMs;

  if (entry?.year != null && entry?.month != null && entry?.day != null) {
    const y = parseInt(entry.year, 10);
    const m = parseInt(entry.month, 10) - 1;
    const d = parseInt(entry.day, 10);
    const date = new Date(y, m, d);
    if (!Number.isNaN(date.getTime())) return date.getTime();
  }

  return 0;
}

export function isBalanceAffectingEntry(entry) {
  if (!entry) return false;
  if (entry.isDeposit || entry.isPayout || entry.isBalanceAdjustment) return true;
  if (isTapeReading(entry) || entry.isResetExcluded) return false;

  const pnl = entry.pnl;
  if (pnl === undefined || pnl === null || pnl === "") return false;
  return !Number.isNaN(Number(pnl));
}

export function buildAccountBalanceTimeline(entries) {
  const sorted = [...(entries || [])].sort((a, b) => {
    const t = getEntrySortTimeMs(a) - getEntrySortTimeMs(b);
    if (t !== 0) return t;
    return String(a?.id || "").localeCompare(String(b?.id || ""));
  });

  let runningBalance = 0;
  return sorted.map((entry) => {
    if (entry?.isBalanceAdjustment) {
      const targetBalance = Number(entry.adjustmentTarget ?? entry.accountBalance);
      runningBalance = Number.isFinite(targetBalance)
        ? roundToCents(targetBalance)
        : roundToCents(runningBalance + (Number(entry.pnl) || 0));
    } else if (isBalanceAffectingEntry(entry)) {
      runningBalance = roundToCents(runningBalance + (Number(entry.pnl) || 0));
    }
    return { entry, accountBalance: runningBalance };
  });
}

export function getLatestAccountBalance(entries) {
  const timeline = buildAccountBalanceTimeline(entries);
  if (!timeline.length) return 0;
  return timeline[timeline.length - 1].accountBalance;
}
